import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Toast from 'vue-toastification';
import { getUserAsync } from './composables/useAuth';
import { vTooltip } from 'floating-vue';

import './assets/main.css';

if (import.meta.env.PROD) {
  // disable console logs in production
  console.log = () => {};
}

const app = createApp(App);

app
  .use(Toast, {
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: false,
    closeButton: false,
    icon: true,
    rtl: false
  })
  .directive('focus', {
    mounted(el, { value = 'input' }) {
      el.querySelectorAll(value)?.[0]?.focus();
    }
  })
  .directive('tooltip', vTooltip);

getUserAsync().then(() => {
  app
    .use(router)
    .mount('#app');
});
